module.exports = __webpack_public_path__ + "static/media/Desktop_Actions_33.cd6cbba1.png";